var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckmarkCircleGreenFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Checkmark Circle_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.99996 1.67627C14.6023 1.67627 18.3333 5.40723 18.3333 10.0096C18.3333 14.612 14.6023 18.3429 9.99996 18.3429C5.39759 18.3429 1.66663 14.612 1.66663 10.0096C1.66663 5.40723 5.39759 1.67627 9.99996 1.67627Z",
    fill: "#15BD66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M12.6831 7.48433L8.95833 11.2091L7.31694 9.56766L7.24684 9.50715C7.00217 9.3256 6.65495 9.34577 6.43306 9.56766C6.18898 9.81174 6.18898 10.2075 6.43306 10.4515L8.51639 12.5349L8.58649 12.5954C8.83117 12.7769 9.17839 12.7568 9.40027 12.5349L13.5669 8.36821L13.6275 8.29811C13.809 8.05344 13.7888 7.70622 13.5669 7.48433C13.3229 7.24025 12.9271 7.24025 12.6831 7.48433Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkCircleGreenFill);
export default __webpack_public_path__ + "static/media/icon-checkmark-circle-green-fill.cab8cc932ee41dde60148b9838b101c5.svg";
export { ForwardRef as ReactComponent };